import {
  Component,
  Input,
  OnInit,
  forwardRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'icp-input',
  templateUrl: './icp-input.component.html',
  styleUrls: ['./icp-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IcpInputComponent),
      multi: true,
    },
  ],
})
export class IcpInputComponent implements OnInit, ControlValueAccessor {
  @Input() id: string;
  @Input() name: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() type: string = 'text';
  @Input() messageError: string;
  @Input() autocomplete: string = 'on';
  @Input() mask: string;
  @Input() dropSpecialCharacters: boolean = false;
  @Input() disabled: boolean = false;
  @Input() maxlength: number;

  @Output() change: EventEmitter<any> = new EventEmitter();

  typeIsPassword = false;
  visibilityPassword = false;
  value = '';
  isTouched = false;
  timeout: ReturnType<typeof setTimeout>;

  showMaxLengthMessage = false;

  onChange!: (value: string) => void;
  onTouched!: () => void;

  constructor() {}

  ngOnInit(): void {
    this.typeIsPassword = this.type === 'password';
  }

  onChangeVisibility() {
    this.visibilityPassword = !this.visibilityPassword;
    this.type = this.visibilityPassword ? 'text' : 'password';
  }

  registerOnChange(onChange: (value: string) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: string) {
    this.value = value;
  }

  onInputChange(value: string) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      if (!this.isTouched) {
        this.isTouched = true;
        this.onTouched();
      }

      this.value = value;
      this.showMaxLengthMessage = this.maxlength && value.length >= this.maxlength;

      setTimeout(() => {
        this.showMaxLengthMessage = false;
      } , 3000);

      this.onChange(value);
      this.change.emit(value);
    }, 500);
  }
}
